import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    defaultMessage:
      "Welcome to the sports universe! I've handpicked these seven sport planets for you. The larger the planet, the better the match.",
    id: 'app.universe.intro'
  },
  noResult: {
    defaultMessage: `No result`,
    id: 'app.universe.noresult'
  },
  showAll: {
    defaultMessage: `Show all >`,
    id: 'app.universe.button.show'
  }
});



// WEBPACK FOOTER //
// ./src/containers/universe/messages.js